// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2WTwm","head":"ProcedureTableInfo_head__zrJiu"};